import { ReactNode } from "react"
import { FormattedMessage } from "react-intl"
import Button from "@rio-cloud/rio-uikit/Button"
import { FreightPaymentDetailsDialog } from "./FreightPaymentDetailsDialog"
import { useAppDispatch, useAppSelector } from "@/redux/store"
import { transportationReportSlice } from "@/redux/transportation-report.slice"
import { isDialogOpen } from "@/redux/transportation-report.selector"

export const FreightPaymentDetailsButton = (): ReactNode => {
    const dispatch = useAppDispatch()
    const dialogOpen = useAppSelector(isDialogOpen)
    const onClick = () => {
        dispatch(transportationReportSlice.actions.setDialogOpen(true))
    }

    return <>
        <Button onClick={onClick}>
            <span className="rioglyph rioglyph-document"/>
            <FormattedMessage id="freightPaymentDetails.button.label"/>
        </Button>
        { dialogOpen && <FreightPaymentDetailsDialog />}
    </>
}
